import { atom } from "recoil";

export const unmountedState = atom({
  key: "unmounted-sidebar",
  default: false,
});

export const hiddenState = atom({ key: "hidden-sidebar", default: true });
